// src/index.ts
var EventEmitter = class {
  // eslint-disable-next-line @typescript-eslint/ban-types
  callbacks = {};
  on(event, fn) {
    if (!this.callbacks[event]) {
      this.callbacks[event] = [];
    }
    this.callbacks[event].push(fn);
    return this;
  }
  once(event, fn) {
    const onceFn = (...args) => {
      this.off(event, onceFn);
      return fn.apply(this, args);
    };
    return this.on(event, onceFn);
  }
  emit(event, ...args) {
    const callbacks = this.callbacks[event];
    const universalCallbacks = this.callbacks["*"];
    if (callbacks) {
      callbacks.forEach((callback) => callback.apply(this, args));
    }
    if (universalCallbacks) {
      universalCallbacks.forEach((callback) => callback.apply(this, [event, ...args]));
    }
    return this;
  }
  off(event, fn) {
    const callbacks = this.callbacks[event];
    if (callbacks) {
      if (fn) {
        this.callbacks[event] = callbacks.filter((callback) => callback !== fn);
      } else {
        delete this.callbacks[event];
      }
    }
    return this;
  }
  removeAllListeners() {
    this.callbacks = {};
  }
};
export {
  EventEmitter
};
